import React, { useState } from 'react';
import GradientButton from './GradientButton';

const RentInputOverlay = ({ isOpen, onClose, onConfirm }) => {
  const [pricePerMatch, setPricePerMatch] = useState('');
  const [currency, setCurrency] = useState('QORBI');

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    setPricePerMatch(e.target.value);
  };

  const handleCurrencyChange = (e) => {
    setCurrency(e.target.value);
  };

  const handleConfirm = () => {
    if (!pricePerMatch) return;
    if (onConfirm) onConfirm({ pricePerMatch, currency });
  };

  return (
    <div className="rent-popup-overlay">
      <div className="rent-popup-content">
        <h2 className="rent-popup-title">Rent Your NFT</h2>
        <p className="rent-popup-description">
          Retain ownership while earning rewards through rentals. Set a price per match below.
        </p>
        <div className="rent-popup-input-row">
          <div className="rent-popup-input-group">
            <label htmlFor="price" className="rent-popup-label">
              Price per Match
            </label>
            <input
              type="number"
              id="price"
              step="100"
              value={pricePerMatch}
              onChange={handleInputChange}
              className="rent-popup-input"
              placeholder="Enter price"
            />
          </div>
          <div className="rent-popup-input-group">
            <label htmlFor="currency" className="rent-popup-label">
              Currency
            </label>
            <select
              id="currency"
              value={currency}
              onChange={handleCurrencyChange}
              className="rent-popup-select"
            >
              <option value="QORBI">QORBI</option>
              <option value="SUPER">SUPER</option>
            </select>
          </div>
        </div>
        <div className="rent-popup-actions">
          <GradientButton
            onTap={onClose}
            text={"Cancel"}
          />
          <GradientButton
            onTap={handleConfirm}
            text={"Confirm"}
          />
        </div>
      </div>
    </div>
  );
};

export default RentInputOverlay;
